var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPostgrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#FDBC15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.642 206V60.5455H146.028C157.061 60.5455 166.459 62.6525 174.224 66.8665C181.99 71.0331 187.908 76.8333 191.98 84.267C196.099 91.6534 198.159 100.176 198.159 109.835C198.159 119.494 196.076 128.017 191.909 135.403C187.742 142.79 181.705 148.543 173.798 152.662C165.938 156.781 156.421 158.841 145.247 158.841H108.67V134.196H140.276C146.194 134.196 151.071 133.178 154.906 131.142C158.789 129.059 161.677 126.194 163.571 122.548C165.512 118.855 166.483 114.617 166.483 109.835C166.483 105.006 165.512 100.792 163.571 97.1932C161.677 93.5473 158.789 90.7301 154.906 88.7415C151.024 86.7055 146.099 85.6875 140.134 85.6875H119.395V206H88.642Z",
    fill: "#E53125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.642 194V48.5455H135.028C146.061 48.5455 155.459 50.6525 163.224 54.8665C170.99 59.0331 176.908 64.8333 180.98 72.267C185.099 79.6534 187.159 88.1761 187.159 97.8352C187.159 107.494 185.076 116.017 180.909 123.403C176.742 130.79 170.705 136.543 162.798 140.662C154.938 144.781 145.421 146.841 134.247 146.841H97.6705V122.196H129.276C135.194 122.196 140.071 121.178 143.906 119.142C147.789 117.059 150.677 114.194 152.571 110.548C154.512 106.855 155.483 102.617 155.483 97.8352C155.483 93.0057 154.512 88.7917 152.571 85.1932C150.677 81.5473 147.789 78.7301 143.906 76.7415C140.024 74.7055 135.099 73.6875 129.134 73.6875H108.395V194H77.642Z",
    fill: "#3C50F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPostgrad);
export default __webpack_public_path__ + "static/media/logo_postgrad.cfa532c9ce9c6d917794d2b62ef8dc90.svg";
export { ForwardRef as ReactComponent };